import { render, staticRenderFns } from "./w-4-5.vue?vue&type=template&id=07d53214"
import script from "./w-4-5.vue?vue&type=script&lang=js"
export * from "./w-4-5.vue?vue&type=script&lang=js"
import style0 from "./w-4-5.vue?vue&type=style&index=0&id=07d53214&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../website-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports